import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../usuario/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RolUserGuard implements CanActivate {
  constructor(private router:Router, private userService:UserService){}

  canActivate() {
    if(this.userService.userIsAdmin()) return true;
    else{
      this.router.navigate(['404'])
      return false;
    }
  }
  
}
